import * as messageService from "../../services/message.service";
import * as leadsService from '../../services/leads.service';
import * as authService from '../../services/auth.service';
const state = {
    //Admin 20220430
    adminLeadsPaginateData:{},
    adminLeadsPaginate:{},
    leadsPaginateData:{},
    leadsPaginate:{},
    leadsSingle:{},
};

const getters = {
    getAdminLeadsPaginateData:state => (state.adminLeadsPaginateData),
    getAdminLeadsPaginate:state => (state.adminLeadsPaginate),
    getLeadsPaginateData:state => (state.leadsPaginateData),
    getLeadsPaginate:state => (state.leadsPaginate),
    getLeadsSingle:state => (state.leadsSingle),
};

const actions = {
    //Admin 221016
    async fetchAdminLeadsPaginate({ commit }, obj){
        commit('setAdminLeadsPaginate', obj)
        try {
            const response = await leadsService.listPage(obj);
            commit('setAdminLeadsPaginateData', response.data);

        } catch (error) {
            console.log('something wrong - fetchAdminLeadsPaginate', error);
        }
    },

    async fetchLeadsPaginate({ commit }, obj){
      commit('setLeadsPaginate', obj)
      try {

        const {role_id} = authService.getUserFromToken();
        /**
         * For BDM - 3
         * For Dealer - 4
         */
        if(role_id == 3){
          const response = await leadsService.listPageBDM(obj);
          commit('setLeadsPaginateData', response.data);
        }else if(role_id == 4 || role_id == 5 ){
          const response = await leadsService.listPageDealer(obj);
          commit('setLeadsPaginateData', response.data);
        }

      } catch (error) {
          console.log('something wrong - fetchLeadsPaginate', error);
      }
    },

    async fetchLeadsSingle({ commit }, id ){
        try {
            const response = await leadsService.single(id);
            commit('setLeadsSingle', response.data);
        } catch (error) {
            const obj = {
                "type":'error',
                "title":error.response.data.error.name,
                "text":error.response.data.error.message,
                "footer":'Error code: ' + error.response.data.error.statusCode,
            }

            messageService.fnSweetAlertDisplay(obj);
        }
    },
};

const mutations = {
    //Admin 20221016
    setAdminLeadsPaginateData:(state, res) => (
      state.adminLeadsPaginateData =  res
    ),
     // For BDM | Dealer
    setLeadsPaginateData:(state, res) => (
      state.leadsPaginateData =  res
    ),
    setAdminLeadsPaginate:(state, res) => (
        state.adminLeadsPaginate =  res
    ),
     // For BDM | Dealer
    setLeadsPaginate:(state, res) => (
      state.leadsPaginate =  res
    ),
    setLeadsSingle:(state, res) => (
        state.leadsSingle =  res
    )
};

export default{
    state,
    getters,
    actions,
    mutations,
}
